"use strict";
import {on, find, addClass, removeClass, hasClass, findAll, findAllIn, findIn, empty} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import Modal from 'bootstrap/js/dist/modal';
import axios from "axios";
import {getPrefixedDataSet} from '@elements/data-set-utils';


export function init () {
    onFind('.js-dl-modal-toggle', function (modalToggle) {
        let modal = find(modalToggle.getAttribute('data-target'));
        let modalSubmit = findIn('.js-dl-modal__submit', modal);
        let modalClose = findIn('.js-dl-modal__close', modal);
        let form = findIn('.js-dl-modal__form', modal);
        let modalInit = new Modal(modal);
        let checkbox = modalToggle.getAttribute('data-modal-checkbox');
        let state = "";
        let dataCollection = modalToggle.getAttribute('data-collection');
        let downloadable = find('.js-downloadable-dl');
        let confirmCheck = findIn(".js-dl-modal__form-check", form).children[1];
        let btnSubmit = findIn('.js-dl-modal__submit', modal)

        if (checkbox === "checkbox"){
            //open modal multiple download
            on('click', function () {
                addClass("disabled", findIn(".js-dl-modal__submit", form))
                confirmCheck.checked = false;
                state = "multi"
                modalInit.show();
            }, modalToggle);

            //submit data for download
            on('click', function () {
                if(state === "multi") {
                    //remove all data from single download if exists

                    btnSubmit.removeAttribute("href");
                    btnSubmit.removeAttribute("download");


                    //prepare data for request
                    let dataset = getPrefixedDataSet("dl-modal", form);
                    let url = dataset.url;
                    let ids = dataset.ids.split(',');
                    let params = new FormData();

                    for (let i = 0; i < ids.length; i++) {
                        params.append('images[]', ids[i]);
                    }

                    //start loading overlay
                    let loading = findIn('.js-loading-modal', modal);
                    addClass("is-loading", loading);
                    loading.removeAttribute("hidden");

                    //request
                    let pendingRequest = axios({method: 'POST', url: url, data: params});
                    let downloadableName = downloadable.getAttribute('data-downloadable');

                    pendingRequest.then((response) => {
                        let success = response.data.success;
                        let url = response.data.url;

                        if (success) {
                            let element = document.createElement('a');
                            element.setAttribute('href', url);
                            element.setAttribute('download', `${downloadableName}.zip`);

                            element.style.display = 'none';
                            document.body.appendChild(element);
                            element.click();
                            document.body.removeChild(element);
                        } else {
                            console.log("FE error");
                        }
                    }).catch((error) => {
                        if (error.name !== 'AbortError') {
                            console.error(error);
                        }
                    }).then(() => {
                        // always executed
                        loading.setAttribute('hidden', true);
                        removeClass('is-loading', loading);
                        modalInit.hide();
                        findAllIn(`.js-${downloadableName}-dl__checkbox`, downloadable).forEach( box => {
                            box.checked = false
                        })
                        find(`.js-${downloadableName}-dl__footer`).hidden = true;
                    });
                    state = "";
                }
            }, modalSubmit);
        } else if(dataCollection !== null) {

            on('click', function () {
                addClass("disabled", findIn(".js-dl-modal__submit", form));
                confirmCheck.checked = false;
                state = "all";
                modalInit.show();
            }, modalToggle);

            on('click', function () {
                if(state === "all") {
                    btnSubmit.removeAttribute("href");
                    btnSubmit.removeAttribute("download");

                    let dataset = getPrefixedDataSet("dl-modal", form);
                    let url = dataset.url;
                    let params = new FormData();
                    params.append('type', modalToggle.getAttribute('data-download-type'));
                    params.append('collection', dataCollection);

                    let loading = findIn('.js-loading-modal', modal);
                    addClass("is-loading", loading);
                    loading.removeAttribute("hidden");

                    let pendingRequest = axios({method: 'POST', url: url, data: params});
                    let downloadableName = downloadable.getAttribute('data-downloadable');
                    pendingRequest.then((response) => {
                        let success = response.data.success;
                        let url = response.data.url;

                        console.log(success)

                        if (success) {
                            let element = document.createElement('a');
                            element.setAttribute('href', url);
                            element.setAttribute('download', `${downloadableName}.zip`);

                            element.style.display = 'none';
                            document.body.appendChild(element);
                            element.click();
                            document.body.removeChild(element);
                        } else {
                            console.log("FE error");
                        }
                    }).catch((error) => {
                        if (error.name !== 'AbortError') {
                            console.error(error.message);
                        }
                    }).then(() => {
                        // always executed
                        loading.setAttribute('hidden', true);
                        removeClass('is-loading', loading);
                        modalInit.hide();
                    });
                    state = "";
                }
            }, modalSubmit);
        }

        else {
            //download data single
            on('click', function () {
                addClass("disabled", findIn(".js-dl-modal__submit", form))
                confirmCheck.checked = false;

                //get data for download
                let href = modalToggle.getAttribute('data-content-url');
                let download = modalToggle.getAttribute('data-download');
                let btnSubmit = findIn('.js-dl-modal__submit', modal)
                btnSubmit.setAttribute("href", href);
                btnSubmit.setAttribute("download", download);
                state = "single"
                modalInit.show();
            }, modalToggle);

            //close modal
            on('click', function(){
                if(state === "single") {
                    modalInit.hide();
                    state=""
                }
            }, modalSubmit);
        }

        //control Btn to submit
        on("change", function(){
            if (confirmCheck.checked === true){
                removeClass("disabled", findIn(".js-dl-modal__submit", form))
            }else {
                addClass("disabled", findIn(".js-dl-modal__submit", form))
            }
        }, form)

        //close modal
        on('click', function(){
            modalInit.hide();
            state=""
        }, modalClose);
    });
}
